import cookie from 'js-cookie';
import { makeSegmentTrackCall } from './analytics';
import { isExperimentActive, getExperimentValue } from './experiments';
import { triggerHeatMap } from './hotjar';

export function sendBucketEvent(experimentKeyToBucket, { triggerHotjar } = {}) {
  if (isExperimentActive(experimentKeyToBucket)) {
    const bucketValue = getExperimentValue(experimentKeyToBucket);
    makeSegmentTrackCall('Bucket', {
      bucket_type: 'experiment',
      bucket_value: bucketValue,
      label: experimentKeyToBucket
    });

    if (triggerHotjar) {
      triggerHeatMap(`${experimentKeyToBucket}_${bucketValue}`);
    }
  }
}

// remove once building reviews experiment is finished, started ~2/18/20
export function sendBuildingReviewsBucketEvent(experimentKeyToBucket, { triggerHotjar } = {}) {
  const bucketValue = getExperimentValue(experimentKeyToBucket);
  makeSegmentTrackCall('Bucket', {
    bucket_type: 'experiment',
    bucket_value: bucketValue,
    label: experimentKeyToBucket
  });

  if (triggerHotjar) {
    triggerHeatMap(`${experimentKeyToBucket}_${bucketValue}`);
  }
}

export function getHeapCookie() {
  const appid = window.heap && window.heap.appid;

  if (!appid) {
    return {};
  }

  const cookieVal = cookie.get(`_hp2_id.${appid}`);

  try {
    return JSON.parse(decodeURIComponent(cookieVal));
  } catch (err) {
    return {};
  }
}
